import PropTypes from "prop-types"
import { Box, SvgIcon, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const IconItem = ({ icon, onSelect, iconName, isCustomIcon }) => {

  return (
    <Box
      data-testid="icon-option"
      sx={{
        width: 80,
        height: 80,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
      onClick={() => onSelect(isCustomIcon ? { name: iconName, icon: { ...icon } } : icon)}
    >
      {isCustomIcon && Array.isArray(icon?.icon) ? (
        <FontAwesomeIcon icon={icon} size="lg" />
      ) : isCustomIcon ? (
        <SvgIcon>
                <svg
                    viewBox={`0 0 ${icon.width} ${icon.height}`}
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    >
                    <path d={icon.pathData} />
                </svg>

        </SvgIcon>
      ) : (
        <FontAwesomeIcon icon={`fa-regular ${icon.icon}`} size="lg" />
      )}
      <Typography
        variant="caption"
        sx={{
          mt: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          textAlign: "center",
          px: 1,
        }}
      >
        {isCustomIcon ? iconName : icon.name}
      </Typography>
    </Box>
  )
}

IconItem.propTypes = {
  icon: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  iconName: PropTypes.string,
  isCustomIcon: PropTypes.bool,
}

export default IconItem

